import React from 'react';
import styles from './O_CapsuleCreateHeader.module.css';
import { Q_Icon } from '@/components/Q_Quarks/Q_Icon/Q_Icon';
import M_LanguageSwitcher from '@/components/M_Molecules/M_LanguageSwitcher/M_LanguageSwitcher';
import { PATHS } from '@/constants/paths';
import A_Button from '@/components/A_Atoms/A_Button/A_Button';
import cn from 'classnames';
import Q_BlurEffect from '@/components/Q_Quarks/Q_BlurEffect/Q_BlurEffect';
import { useTranslation } from '@/hooks/useTranslation';

interface O_CapsuleCreateHeaderProps {
  onSaveContent?: (contentItem: any) => void;
  onPreviewClick?: () => void;
  onPublishClick?: () => void;
  onOpenAddContent?: () => void;
  isScenarioPreview?: boolean;
  showPreviewButton?: boolean;
  showUploadButton?: boolean;
}

export default function O_CapsuleCreateHeader({
  onPreviewClick,
  onPublishClick,
  onOpenAddContent,
  isScenarioPreview = false,
  showPreviewButton = false,
  showUploadButton = false,
}: O_CapsuleCreateHeaderProps) {
  const t = useTranslation();
  const shouldShowPreviewButton = showPreviewButton;
  const shouldShowPublishButton = isScenarioPreview;
  const shouldShowUploadButton = showUploadButton && !isScenarioPreview;
  return (
    <header className={styles.wrapper}>
      <Q_BlurEffect
        yAxis='top'
        zIndex={-1}
        withBackground={isScenarioPreview ? false : true}
      />
      <div className={styles.left_wrapper}>
        <button
          className={styles.back_button}
          onClick={() => {
            window.location.href = PATHS.CAPSULES;
          }}
        >
          <Q_Icon.BackArrowIcon
            width={33}
            height={12}
            fill='none'
            stroke={
              isScenarioPreview
                ? 'var(--color-surface-white)'
                : 'var(--color-text-dark-fill-600)'
            }
          />
          <span
            className={cn(styles.back_button_text, 'text-p-6')}
            style={{
              color: isScenarioPreview
                ? 'var(--color-surface-white)'
                : 'var(--color-text-dark-fill-600)',
            }}
          >
            {t('header.toMyCapsules')}
          </span>
        </button>
        <M_LanguageSwitcher />
      </div>
      <div className={styles.right_wrapper}>
        {shouldShowUploadButton && (
          <A_Button
            variant='secondary'
            size='small'
            fontSize='text-p-4'
            icon={
              <Q_Icon.PlusIcon width={16} height={16} fill='currentColor' />
            }
            showIcon
            onClick={onOpenAddContent}
          >
            {t('header.upload')}
          </A_Button>
        )}
        {shouldShowPreviewButton && (
          <A_Button
            variant='primary'
            size='small'
            fontSize='text-p-4'
            icon={
              <Q_Icon.PreviewIcon width={16} height={24} fill='currentColor' />
            }
            showIcon={true}
            onClick={onPreviewClick}
          >
            {t('header.preview')}
          </A_Button>
        )}
        {shouldShowPublishButton && (
          <A_Button
            variant='primary'
            size='small'
            fontSize='text-p-4'
            onClick={onPublishClick}
          >
            {t('capsuleReactions.create')}
          </A_Button>
        )}
      </div>
    </header>
  );
}
